import { connect } from "react-redux";
import { guiTinNhan, showModalGuiTinNhan } from "actions/GuiTinNhan";
import TinNhanSMS from "components/CommonComponent/TinNhanSMS";

const mapStateToProps = (state) => ({
  guitinnhan: state.guitinnhan,
  camdo: state.camdo,
});

const mapDispatchToProps = (dispatch) => ({
  guiTinNhan: (dataPost) => dispatch(guiTinNhan(dataPost)),
  showModalGuiTinNhan: () => dispatch(showModalGuiTinNhan()),
});

export default connect(mapStateToProps, mapDispatchToProps)(TinNhanSMS);
